import { http } from "@/lib/api";

const SESSION_KEY = "kx_session_id";
const VISITED_KEY = "kx_has_visited";

function ensureSessionId() {
  let sid = sessionStorage.getItem(SESSION_KEY);
  if (!sid) {
    sid = "s_" + Math.random().toString(36).slice(2) + Date.now().toString(36);
    sessionStorage.setItem(SESSION_KEY, sid);
  }
  return sid;
}

function detectDevice() {
  const ua = navigator.userAgent || "";
  if (/iPad|Tablet/i.test(ua)) return "tablet";
  if (/Mobi|Android|iPhone/i.test(ua)) return "mobile";
  return "desktop";
}

function isReturning() {
  const v = localStorage.getItem(VISITED_KEY);
  localStorage.setItem(VISITED_KEY, "1");
  return !!v;
}

let inflight = new Set();

export async function track(type, payload = {}) {
  try {
    const body = {
      type,
      session_id: ensureSessionId(),
      device: detectDevice(),
      referrer: document.referrer || "",
      path: window.location.pathname,
      is_returning: isReturning(),
      ...payload,
    };
    const key = `${type}:${body.path}:${payload.platform || ""}:${payload.release_id || ""}:${payload.query || ""}`;
    if (inflight.has(key)) return;
    inflight.add(key);
    setTimeout(() => inflight.delete(key), 800);
    await http.post("/analytics/event", body);
  } catch (_) {
    /* analytics failures are silent */
  }

  // Google Analytics 4 mirroring (loaded conditionally in index.html)
  try {
    if (window.gtag) window.gtag("event", type, payload);
  } catch (_) { /* noop */ }
}

export const trackPageview = () => track("pageview");
export const trackPlatformClick = (platform, release_id = "") => track("platform_click", { platform, release_id });
export const trackPlay = (release_id) => track("play", { release_id });
export const trackSearch = (query) => track("search", { query });
export const trackDonation = (amount, method = "upi") => track("donation", { meta: { amount, method } });
